import { useState, FormEvent } from 'react';
import { Product } from '../types';

interface AddProductModalProps {
  onSubmit: (product: Omit<Product, 'id' | 'created_at' | 'updated_at'>) => void;
  onCancel: () => void;
}

export function AddProductModal({ onSubmit, onCancel }: AddProductModalProps) {
  const [formData, setFormData] = useState({
    amazon_url: 'https://www.amazon.fr/dp/',
    custom_name: '',
    alert_threshold: '10',
  });
  const [error, setError] = useState('');

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    setError('');

    if (!formData.amazon_url || !formData.amazon_url.startsWith('http')) {
      setError('Veuillez entrer une URL Amazon valide');
      return;
    }

    if (!formData.custom_name.trim()) {
      setError('Veuillez entrer un nom pour le produit');
      return;
    }

    const threshold = parseFloat(formData.alert_threshold);
    if (isNaN(threshold) || threshold < 1 || threshold > 100) {
      setError('Le seuil doit être entre 1 et 100%');
      return;
    }

    onSubmit({
      amazon_url: formData.amazon_url.trim(),
      custom_name: formData.custom_name.trim(),
      alert_threshold: threshold,
    });
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      {error && (
        <div className="p-3 bg-red-900/30 border border-red-700 rounded-lg text-red-300 text-sm">
          {error}
        </div>
      )}

      <div>
        <label className="label">URL Amazon.fr</label>
        <input
          type="url"
          value={formData.amazon_url}
          onChange={(e) => setFormData({ ...formData, amazon_url: e.target.value })}
          className="input"
          placeholder="https://www.amazon.fr/dp/B08N5M7S6C"
          autoFocus
        />
        <p className="text-xs text-gray-500 mt-1">Ex: https://www.amazon.fr/dp/B08N5M7S6C</p>
      </div>

      <div>
        <label className="label">Nom personnalisé</label>
        <input
          type="text"
          value={formData.custom_name}
          onChange={(e) => setFormData({ ...formData, custom_name: e.target.value })}
          className="input"
          placeholder="Mon produit Amazon"
        />
      </div>

      <div>
        <label className="label">Seuil d'alerte (%)</label>
        <input
          type="number"
          min="1"
          max="100"
          value={formData.alert_threshold}
          onChange={(e) => setFormData({ ...formData, alert_threshold: e.target.value })}
          className="input"
        />
        <p className="text-xs text-gray-500 mt-1">Alerte si le prix baisse de plus de ce pourcentage</p>
      </div>

      <div className="flex justify-end gap-3 pt-4 border-t border-gray-700">
        <button type="button" onClick={onCancel} className="btn btn-secondary">Annuler</button>
        <button type="submit" className="btn btn-primary">💾 Sauvegarder</button>
      </div>
    </form>
  );
}